import { getSessionItem } from "./session";


/**
 * Returns the user's timezone (e.g. "America/Sao_Paulo -03:00")
 * extracted from sessionStorage User.timezone
 *
 * Expected format:
 * "America/Sao_Paulo -03:00"
 *
 * @returns {string} timezone "+00:00" as fallback
 */
export const userTimezone = () => {
  const user = getSessionItem("User");
  if (!user?.timezone || typeof user.timezone !== "string") {
    return "+00:00";
  }


  return user.timezone;
};
